import React from 'react';
import { CommandButton, Stack } from 'office-ui-fabric-react';
import { formatDateTime } from 'buzz_lib_shared';
import { Tooltip } from '../Tooltip';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StatusControl = props => {
  var _props$prefix;
  const menuItems = Object.values(props.options).map(item => {
    return {
      key: item,
      text: item.replace(/([A-Z])/g, ' $1').trim(),
      onClick: () => {
        props.onItemClick(item);
      },
      iconProps: {
        iconName: props.iconNameFactory(item),
        styles: {
          root: {
            color: props.iconColorFactory(item)
          }
        }
      }
    };
  });
  const MenuProps = {
    shouldFocusOnMount: true,
    items: menuItems
  };
  const iconColor = props.iconColorFactory(props.value);
  const iconName = props.iconNameFactory(props.value);
  return /*#__PURE__*/_jsx(Tooltip, {
    tooltipBody: /*#__PURE__*/_jsx(_Fragment, {
      children: "Set to ".concat(props.value, " on ").concat(formatDateTime(new Date(props.updatedOn)), " by ").concat(props.createdBy)
    }),
    children: /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      verticalAlign: 'center',
      styles: {
        root: {
          color: iconColor
        }
      },
      children: [props.children, /*#__PURE__*/_jsx(CommandButton, {
        disabled: props.disabled,
        iconProps: {
          iconName: iconName,
          styles: {
            root: {
              color: iconColor
            }
          }
        },
        text: "".concat((_props$prefix = props.prefix) !== null && _props$prefix !== void 0 ? _props$prefix : '').concat(props.value),
        menuProps: MenuProps
      })]
    })
  });
};